import { render, staticRenderFns } from "./tablePtenAction.vue?vue&type=template&id=dbf9dd3a&scoped=true"
import script from "./tablePtenAction.vue?vue&type=script&lang=js"
export * from "./tablePtenAction.vue?vue&type=script&lang=js"
import style0 from "./tablePtenAction.vue?vue&type=style&index=0&id=dbf9dd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf9dd3a",
  null
  
)

export default component.exports